import { CreditCardFeesResponse } from '../types/payment'

class AsaasApi {
  constructor(
    private readonly BASE_URL = import.meta.env.VITE_CONECTOR_N8N_BASE_URL
  ) {
    if (!this.BASE_URL) {
      throw new Error('VITE_CONECTOR_N8N_BASE_URL não definida')
    }
  }

  getCreditCardFees = async (): Promise<CreditCardFeesResponse> => {
    try {
      const response = await fetch(`${this.BASE_URL}/installments`, {
        method: 'GET',
        headers: {
          Authorization: 'Bearer 123456',
        },
      })
      if (!response.ok) {
        throw new Error(`Erro ao obter taxas`)
      }

      const creditCardFees = (await response.json()) as CreditCardFeesResponse
      return creditCardFees
    } catch (error) {
      console.error('Erro ao obter taxas de cartão de crédito: ', error)
      throw new Error('Erro ao obter taxas de cartão de crédito')
    }
  }
}

export const asaasApi = new AsaasApi()
